import { gridSize } from '@atlaskit/theme';

export const SCROLL_TO_DURATION = 600;
export const SCROLL_TO_TOP_DURATION = 1500;
export const PERMALINK_DELAY = SCROLL_TO_DURATION + 100;
export const COMMENT_PERMALINK_SCROLL_OFFSET = gridSize() * 2;
export const LINE_PERMALINK_SCROLL_OFFSET = gridSize() / 2;
export const SIDEBAR_EXPANDER_SCROLL_OFFSET = 2 * (gridSize() * 4);
